const state = {
  appsData: null,
  filters: {
    category_id: null,
    term: ''
  }
}

export default state;
  